import { Directive } from '@angular/core';

/**
 * Button Utility Directive
 *
 * Adds utility button styling to PrimeNG buttons.
 * Use with p-button to create icon-only utility buttons.
 *
 * @example
 * <p-button pButtonUtility icon="pi pi-cog" />
 *
 * @usageNotes
 * The directive uses attribute selector styling - no class manipulation needed.
 * Styles are applied via [pButtonUtility] CSS selector in the preset.
 */
@Directive({
  selector: 'p-button[pButtonUtility], button[pButton][pButtonUtility], a[pButton][pButtonUtility]',
  standalone: true,
})
export class ButtonUtilityDirective {}
